import styled from 'styled-components';

export const ShapeBtnWrap = styled.div<{ $disabled: boolean }>`
	display: flex;
	height: 30px;
	align-items: center;
	padding: 0 4px;
	opacity: ${({ $disabled }) => ($disabled ? 0.4 : 1)};
`;

export const ShapeBtn = styled.label<{ $disabled: boolean; $isLast: boolean }>`
	display: flex;
	align-items: center;
	cursor: ${({ $disabled }) => ($disabled ? 'not-allowed' : 'pointer')};
	border-right: ${({ $isLast }) => ($isLast ? 'none' : '1px dashed var(--borderLightColor)')};
	padding: 0 0.5rem;
	background: var(--defaultBgColor);
	height: 20px;
	min-width: 30px;

	input {
		position: absolute;
		opacity: 0;
		cursor: pointer;
		height: 0;
		width: 0;
	}

	svg {
		display: block;
	}
`;
